<template>
  <div @click="message" class="right-navbar-msg">
    <i class="iconfont icon-xiaoxixinxihuihuahuida"></i>
    <span v-show="has_red_point > 0" class="redPointMessage"></span>
  </div>
</template>
<script>
import { mapMutations } from "vuex";
export default {
  data() {
    return {
      // 未读消息个数
      has_red_point: null,
    };
  },
  activated() {
    this.init();
  },
  methods: {
    ...mapMutations("message", ["changeMessage"]),
    init() {
      let url = "index.php/mobile/message/new-count";
      let params = {
        is_read: 0,
      };
      this.$axios.post(url, params).then((res) => {
        // console.log("未读消息返回值", res);
        if (res.data.code === 0) {
          this.has_red_point =
            Number(res.data.result.count) < 99
              ? Number(res.data.result.count)
              : 99;
          // this.$store.state.
          this.changeMessage({
            sys_count: Number(res.data.result.sys_count),
            custom_count: Number(res.data.result.custom_count),
          });
        }
      });
    },
    message() {
      this.$router.push({ name: "message" });
    },
  },
};
</script>

<style scoped lang="less">
.right-navbar-msg {
  position: relative;
  .iconfont {
    font-size: 0.54rem;
    vertical-align: middle;
  }
}
.redPointMessage {
  position: absolute;
  right: 0.08rem;
  top: 0.25rem;
  width: 0.12rem;
  height: 0.12rem;
  background: #f75d5d;
  border-radius: 50%;
  color: white;
  line-height: 0.3rem;
  text-align: center;
  font-size: 0.2rem;
}
</style>
